export default __webpack_public_path__ + "static/O0282-9fd10973e82efd48eedb2b0352eee60e.png";